import React,{Component} from 'react';



class QApproved extends Component{
    
    
    render() {

        return (
            <tr>
                <td >
                    <p>{this.props.quote.quoteNumber}</p>
                </td>
                <td >
                    <p>{this.props.quote.customer.name}</p>
                </td>
                <td >
                    <p>{this.props.quote.customer.location}</p>
                </td>
                <td >
                    <p>{this.props.quote.customer.representative}</p>
                </td>
                <td >
                    <p>{this.props.quote.status}</p>
                </td>
                <td >
                    <div className="btn-group btn-group-xs">
                        <button className="btn btn-default" type="button" onClick={()=>this.props.approved(this.props.index)}><i className="fa fa-check"></i></button>
                        <button className="btn btn-xs btn-danger" type="button" onClick={()=>this.props.disapproved(this.props.index)}><i className="fa fa-times"></i></button>
                        <button className="btn btn-default" type="button" onClick={()=>this.props.view(this.props.index)}><i className="fa fa-eye"></i></button>  
                    </div>
                </td>
                                                                                                                       
            </tr>   
                
        );
    }
}

export default  QApproved;



// WEBPACK FOOTER //
// ./src/components/QApproved.js